export const kazakhstanPageFooterTexts = {
  aboutCompany: `© ${new Date().getFullYear()}, ТОО «ИТ ХАБ Казахстан». При использовании материалов гиперссылка на
        sravni.ru обязательна.`,
  address: 'БИН 220940045572. 050046, г. Алматы, проспект Сейфуллина 617, 4 этаж OFFICE COWORKING, 22 кабинет.',
  companyActivities: `ТОО «ИТ ХАБ Казахстан» осуществляет деятельность в сфере IT: сервис предоставляет онлайн - услуги по подбору финансовых продуктов организаций - партнеров.`,
  cookie:
    'Мы используем файлы cookie для того, чтобы предоставить пользователям больше возможностей при посещении сайта sravni.ru.',
  moreAboutTerms: 'Подробнее об условиях использования.',
};
